import MetaData from  '../../../mixins/meta-data.js'

export default {
  name: 'procurement',
  data(){
      return {
          tabs: []
      }
  },

  computed: {
      // returns the index of the selected tab  or changes the route to the given tab by its index.
      activeTab: {
          get: function () {
              return this.tabs ? this.tabs.findIndex((tab)=>tab.name === this.$route.name) : 0;
          },
          set: function ($tabIndex) {
              var tab = this.tabs[$tabIndex]
              if (this.$route.name !== tab.name) {
                  this.$router.push({name: tab.name});
              }
          }
      }
  },

  methods: {
    pushRoute(el) {
      this.$router.push({name: el.name})
    }
  },

  beforeMount(){
        //dynamically determine the tabs based on the procurement route's children found in router/footer-nav.js
      var parentRoute = this.$route.matched.find((route)=>route.parent == undefined)
      this.tabs =  this.$router.options.routes.find((r)=>r.name === parentRoute.name).children || [];
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/procurement/procurement.js